var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0402 6.82213L14.2802 2.79214C12.7102 1.69214 10.3002 1.75213 8.79023 2.92213L3.78023 6.83213C2.78023 7.61213 1.99023 9.21214 1.99023 10.4721V17.3721C1.99023 19.9221 4.06023 22.0021 6.61023 22.0021H17.3902C19.9402 22.0021 22.0102 19.9321 22.0102 17.3821V10.6021C22.0102 9.25214 21.1402 7.59213 20.0402 6.82213ZM12.7502 18.0021C12.7502 18.4121 12.4102 18.7521 12.0002 18.7521C11.5902 18.7521 11.2502 18.4121 11.2502 18.0021V15.0021C11.2502 14.5921 11.5902 14.2521 12.0002 14.2521C12.4102 14.2521 12.7502 14.5921 12.7502 15.0021V18.0021Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.95afd4e724b84f522aafff02a2682cb9.svg";
export { ForwardRef as ReactComponent };